import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaWhatsapp, FaTelegramPlane } from 'react-icons/fa';
import api from '@/lib/api';
import { IDS } from '@/constants/testIds';

export default function FloatingContacts() {
  const [s, setS] = useState({});
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    api.get('/settings/public').then((r) => setS(r.data)).catch(() => {});
    const onScroll = () => setVisible(window.scrollY > 500);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const phone = (s.whatsapp_phone || '+918958956564').replace(/[^+\d]/g, '');
  const waLink = `https://wa.me/${phone.replace('+', '')}?text=Здравствуйте! Интересует тур в Индию`;
  const tgLink = `https://t.me/${(s.telegram_username || '+918958956564').replace(/^\+/, '')}`;

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 30 }}
          className="fixed bottom-6 right-6 z-40 flex flex-col gap-3"
        >
          <motion.a
            data-testid={IDS.floatingWhatsapp}
            href={waLink}
            target="_blank"
            rel="noopener noreferrer"
            whileHover={{ scale: 1.08 }}
            whileTap={{ scale: 0.94 }}
            className="w-14 h-14 rounded-full bg-[#25D366] text-white flex items-center justify-center shadow-2xl shadow-black/40 text-2xl"
            aria-label="Написать в WhatsApp"
          >
            <FaWhatsapp />
          </motion.a>
          <motion.a
            data-testid={IDS.floatingTelegram}
            href={tgLink}
            target="_blank"
            rel="noopener noreferrer"
            whileHover={{ scale: 1.08 }}
            whileTap={{ scale: 0.94 }}
            className="w-14 h-14 rounded-full bg-[#26A5E4] text-white flex items-center justify-center shadow-2xl shadow-black/40 text-2xl"
            aria-label="Написать в Telegram"
          >
            <FaTelegramPlane />
          </motion.a>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
